import { ThumbnailImage, SpinnerLoading } from './styles'

export const ThumbnailImg = (image) => {
  return (
    <ThumbnailImage src={image.image} alt='add-image' />
  )
}
